import { createAction } from '@reduxjs/toolkit';

export const resetAllSlicesState = createAction('RESET_ALL');
